import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Grid, TextField, Divider, Button } from '@mui/material';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/system';
import ApiHelper from 'utils/apiHelper';

const AddViewListDialog = (props) => {
    // eslint-disable-next-line react/prop-types
    const { onClose, onCloseCancel, selectedFilters } = props;
    const theme = useTheme();
    const navigate = useNavigate();
    const [disableAddClause, setDisableAddClause] = useState(true);
    const [viewName, setViewName] = useState('');
    const handleSubmit = () => {
        ApiHelper.post('/api/management/add_view/', {
            view_name: viewName,
            // eslint-disable-next-line react/prop-types
            group_id: selectedFilters.group.id,
            // eslint-disable-next-line react/prop-types
            device_type_id: selectedFilters.deviceType.id,
            // eslint-disable-next-line react/prop-types
            policy_id: selectedFilters.policy.id,
            // eslint-disable-next-line react/prop-types
            license_id: selectedFilters.license.id,
            // eslint-disable-next-line react/prop-types
            label_id: selectedFilters.label.id
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.success(response.data.message);
                    navigate('/management/views');
                }
            })
            .catch((err) => {
                toast.error(`Failed! ${err.response?.data?.error}`);
            });
    };

    useEffect(() => {
        if (viewName !== '') {
            setDisableAddClause(false);
        } else {
            setDisableAddClause(true);
        }
    }, [viewName]);

    return (
        <Dialog open={true} onClose={onCloseCancel}>
            <DialogTitle sx={{ fontSize: '16px' }}>Add View List</DialogTitle>
            <DialogContent sx={{ minWidth: '900px' }}>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <TextField
                                sx={{ width: '100%' }}
                                label="View Name"
                                // eslint-disable-next-line react/prop-types
                                value={viewName}
                                onChange={(e) => setViewName(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ border: `1px solid ${theme.palette.primary.main}`, mt: 2, mb: 2 }} />
                    <Grid container spacing={1} sx={{ mb: 2 }}>
                        <Grid item xs={4}>
                            <TextField
                                sx={{ width: '100%' }}
                                label="Group"
                                // eslint-disable-next-line react/prop-types
                                value={selectedFilters.group.name}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                sx={{ width: '100%' }}
                                label="Device Type"
                                // eslint-disable-next-line react/prop-types
                                value={selectedFilters.deviceType.name}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                sx={{ width: '100%' }}
                                label="Policy"
                                // eslint-disable-next-line react/prop-types
                                value={selectedFilters.policy.name}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <TextField
                                sx={{ width: '100%' }}
                                label="License"
                                // eslint-disable-next-line react/prop-types
                                value={selectedFilters.license.name}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                sx={{ width: '100%' }}
                                label="Label"
                                // eslint-disable-next-line react/prop-types
                                value={selectedFilters.label.name}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit} disabled={disableAddClause}>
                    Add View
                </Button>
                <Button onClick={onCloseCancel}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddViewListDialog;
